import AppFooter from "./AppFooter";
import AppHeader from "./AppHeader";

export default function Layout({ children }) {
	return <>
		<AppHeader />
		{children}
		<AppFooter />
	</>;
}